// extracted by mini-css-extract-plugin
export default {"div":"DesktopWin_div__tpTKk","header":"DesktopWin_header__4n9JX","text":"DesktopWin_text__giXsH","img":"DesktopWin_img__Sq4r+"};